'use client';
import { create } from 'zustand';
import { CategoryName, GradeLevel } from '@/lib/worksheetData';

type SortOption = 'newest' | 'most-downloaded' | 'title-az';

interface WorksheetStore {
  searchQuery: string;
  selectedCategory: CategoryName | 'All';
  selectedGrade: GradeLevel | 'All';
  sortBy: SortOption;
  setSearchQuery: (q: string) => void;
  setSelectedCategory: (c: CategoryName | 'All') => void;
  setSelectedGrade: (g: GradeLevel | 'All') => void;
  setSortBy: (s: SortOption) => void;
}

export const useWorksheetStore = create<WorksheetStore>((set) => ({
  searchQuery: '',
  selectedCategory: 'All',
  selectedGrade: 'All',
  sortBy: 'newest',
  setSearchQuery: (q) => set({ searchQuery: q }),
  setSelectedCategory: (c) => set({ selectedCategory: c }),
  setSelectedGrade: (g) => set({ selectedGrade: g }),
  setSortBy: (s) => set({ sortBy: s }),
}));